// Outbound links used by more than one public component.
// The Slack invite is the club's real join step (see PRODUCT.md).
export const SLACK_JOIN_URL = 'https://linktr.ee/purduesearch#281987267';
export const DONATE_URL = 'https://giving.purdue.edu/west-lafayette/?q=search';
